import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 4px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  margin: 50px;
  padding: 50px;

  .check {
    width: 88px;
    height: 88px;
    margin-bottom: 32px;
    color: ${ ({ theme }) => theme.colors.primary };
  }

  h3 {
    margin: 0 0 12px;
    font-size: 20px;
    font-weight: bold;
    color: ${ ({ theme }) => theme.colors.primary };
    text-align: center;
  }

  p {
    margin: 0 0 48px;
    font-size: 14px;
    color: ${ ({ theme }) => theme.colors.greyDark };
    text-align: center;
  }

  .acceptButton {
    width: max-content;
    min-width: 100px;
    padding: 12px 24px;
    font-size: 12px;
  }

  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0;
    overflow: auto;
    padding: 30px;
  }
`
